export const buildBreadcrumbs = ({
  breadcrumbs,
  uuid,
  name,
  search,
  mediaCenterPath,
  mediaCenterFolderPath,
  menuName = __('Media Center'),
}) => {
  if (!breadcrumbs || !breadcrumbs?.length || !uuid) {
    return null;
  }

  const fullBreadcrumb = breadcrumbs.map((elem, index) => {
    if (index === 0) {
      return {
        ...elem,
        name: menuName,
        to: { pathname: mediaCenterPath(), search },
        hasEllipsis: false,
        active: false,
      };
    }

    return {
      ...elem,
      to: { pathname: mediaCenterFolderPath(elem.uuid), search },
      active: false,
    };
  });

  fullBreadcrumb.push({
    name,
    uuid,
    active: true,
  });

  return fullBreadcrumb;
};
